import { Button, Checkbox, Dropdown, Input, Menu } from 'antd'
import { FilterFilled, SearchOutlined } from '@ant-design/icons'
import React, { useState } from 'react'

import { CheckboxValueType } from 'antd/lib/checkbox/Group'
import { getDisplayValue } from '../../util/LiveboardUtil'
import { isUndefined } from 'lodash'

interface MoreFilterItemProps {
  item: any
  filter: any
  setMoreFilter: (item: any, checkedValues: CheckboxValueType[]) => void
}

interface MoreFiltersDropdownProps {
  configs: any[]
  filter: any
  setMoreFilter: (item: any, checkedValues: CheckboxValueType[]) => void
}

export function MoreFiltersDropdown({
  configs,
  filter,
  setMoreFilter,
}: MoreFiltersDropdownProps) {
  if (!configs || configs.length === 0) return null

  return (
    <Dropdown
      className="dropdown-container"
      overlay={
        <Menu className="lb-more-filter-dropdown">
          {configs.map((item) => (
            <Menu.SubMenu key={item.key} title={item.name}>
              <RenderSubMenuItem
                item={{
                  ...item,
                  options: item.options.map((opt: any) => ({
                    ...opt,
                    value: opt.name,
                  })),
                }}
                filter={filter}
                setMoreFilter={setMoreFilter}
              />
            </Menu.SubMenu>
          ))}
        </Menu>
      }
    >
      <Button
        className="more-filter-button"
        type="ghost"
        size={'large'}
        icon={<FilterFilled />}
      >
        More Filters
      </Button>
    </Dropdown>
  )
}

// New component: Each filter gets its own independent dropdown
function RenderSubMenuItem({
  item,
  filter,
  setMoreFilter,
}: MoreFilterItemProps) {
  const [searchText, setSearchText] = useState('')

  const filteredOptions = item.options.filter((option) =>
    getDisplayValue(option, item.name)
      .toLowerCase()
      .includes(searchText.toLowerCase())
  )

  return (
    <Menu className="lb-custom-dropdown-menu">
      <div
        key="search"
        className="ant-dropdown-menu-item search-menu-item"
        onClick={(e) => e.stopPropagation()}
        style={{ cursor: 'default', paddingTop: '12px' }}
      >
        <Input
          placeholder="Search..."
          prefix={<SearchOutlined />}
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          onClick={(e) => e.stopPropagation()}
        />
      </div>

      {filteredOptions.length > 0 ? (
        filteredOptions.map((option: any) => {
          const isChecked =
            !isUndefined(filter[item.key]) &&
            filter[item.key].some((f: any) => f?.key === option?.key)

          const handleToggle = (checked: boolean) => {
            const currentValues = !isUndefined(filter[item.key])
              ? filter[item.key].map((f: any) => f?.key)
              : []

            const newValues = checked
              ? [...currentValues, option.key]
              : currentValues.filter((k) => k !== option.key)

            setMoreFilter(item, newValues)
          }

          return (
            <div
              className="ant-dropdown-menu-item"
              key={option?.key}
              onClick={(e) => {
                e.stopPropagation()
                handleToggle(!isChecked)
              }}
              style={{ cursor: 'pointer' }}
            >
              <Checkbox
                className="custom-dropdown-checkbox-full"
                checked={isChecked}
                style={{ pointerEvents: 'none' }}
              >
                {getDisplayValue(option, item.name)}
              </Checkbox>
            </div>
          )
        })
      ) : (
        <Menu.Item key="no-results" disabled>
          <div style={{ textAlign: 'center', color: '#999' }}>
            No results found
          </div>
        </Menu.Item>
      )}
    </Menu>
  )
}
